// Converted from application/views/milestones_v.php. Edit this component directly.
export default function MilestonesPage() {
  return <><div class={"firstContainer container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/milestones/wind-and-sea-wax-statue-working-in-florence.jpg"} alt={"Paddy Campbell working with the wax of “Windand Sea”sculpture at his studio in Via Luna, Florence"} />
<figcaption>{"Paddy Campbell working with the wax of “Wind and Sea” sculpture at his studio in Via Luna, Florence"}</figcaption>
</figure>
<div class={"text"}>
<div>
<h1 style={{"fontSize":"3.2rem"}}>{"MILESTONES IN THE LIFE OF"}<br />{"PADDY CAMPBELL"}</h1>
<h2 style={{"fontSize":"1.8rem"}}>{"The Journey of an Irish Sculptor in Florence 2000–2023"}</h2>
</div>
</div>
</div>
<div class={"container photoRight"}>
<div class={"text"}>
<div>
<p>{"\n                Born  in  Dublin in 1942,  Paddy  Campbell  loved  to  draw  and  paint from his early childhood.\n            "}</p>
<p>{"\n                He excelled in art at school and college, but he chose a career in hospitality and started his own catering business when he was 25years old.\n            "}</p>
<p>{"\n                This creative nature found expression through enterprise, and his business grew to become an international success story.\n            "}</p>
<p>{"\n                On his 50th birthday Campbell made a life changing decision, to let go of his life as a businessman and concentrate instead on his first love as an artist.\n            "}</p>
<p>{"\n                He began to spend more and more time in Florence in the 1990’s studying and practicing Renaissance drawing and painting techniques.\n            "}</p>
</div>
</div>
<figure class={"photo"}>
<img src={"/assets/images/milestones/Bewleys-Coffee-Roastery-Dublin.jpg"} alt={"Bewley’sCoffee Roastery, Northern Cross, Bewley’s Café Grafton Street,Dublin, Dublin "} />
<figcaption>{"Bewley’s Roastery, Northern Cross, Dublin"}</figcaption>
</figure>
</div>
<div class={"container photoLeft"}>
<figure class={"photo"}>
<img src={"/assets/images/milestones/rugby-player-figure-in-florence.jpg"} alt={"Making the figure of a Rugby player at Studio Via Luna"} />
<figcaption>{"Making the figure of a Rugby player at Studio Via Luna"}</figcaption>
</figure>
<div class={"text"}>
<div>
<p>{"\n                By 2001 he had discovered that his true gift was sculpture. From that point he dedicated himself to learning the three-dimensional methods of the Florentine masters.\n            "}</p>
<p>{"\n                In 2005 Campbell set up his studio at via Luna in Florence where he has since shown exceptional versatility, creating a series of small, lifesize, and monumental sculptures, in wax, bronze and marble.\n            "}</p>
<p>{"\n                In the past 20 years of his life as an artist Campbell has created an extraordinary series of sculptures, commissions, exhibitions, scenarios, installations in Dublin, London, Florence, Cork, Belfast, Positano, Capri, Alghero, Fiesole, Vicchio and other parts of Europe.\n            "}</p>
</div>
</div>
</div>
<div class={"container"} style={{"margin":"0 2rem"}}>
<blockquote style={{"textAlign":"center"}}>
<p>{"Each of Paddy Campbell’s sculptures tells a story."}</p>
</blockquote>
<p style={{"textAlign":"center"}}>{"\n        What interests him is “the blending of experiences of the subject, the artist, and the observer, and the infinite possibilities of interpretation.”\n    "}</p>
</div>
<div class={"container fullPhoto"}>
<div class={"text"}>
<div>
<h2>{"Selected Milestones"}</h2>
</div>
</div>
</div>
<ul class={"twoColumnsList"}>
<li>
<figure>
<img src={"/assets/images/milestones/spirit-of-love-statue.jpg"} alt={"2006 “Spirit of Love” Memorial, Bantry Bay, Cork"} />
<figcaption>
<b>{"2006"}</b>{" “Spirit of Love” Memorial,"}<br />{"Bantry Bay, Cork\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/milestones/blue-lady-sculpture-exhibition-florence-italy.jpg"} alt={"Blue Lady,”Solo 70” Exhibition, Florence"} />
<figcaption>
<b>{"2010"}</b>{" Blue Lady, “Solo 70” Exhibition,"}<br />{"Florence\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/la-principessa-e-la-ranocchia-sculpture-exhibition-fiesole-italy.jpg"} alt={"2010 “La Principesse e La Rana”,Un Altro Mondo (Another World)Exhibition,Fiesole, Italy"} />
<figcaption>
<b>{"2010"}</b>{" “La Principesse e La Rana”, Un Altro Mondo (Another World)Exhibition,"}<br />{"Fiesole, Italy\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/milestones/official-sculpture-portrait-mary-mcaleese-president-of-ireland.jpg"} alt={"2011 Official Portrait of Mary McAleese, President of Ireland(1997-2011)"} />
<figcaption>
<b>{"2011"}</b>{" Official Portrait of Mary McAleese,"}<br />{"President of Ireland (1997-2011)\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/wind-and-sea-sculpture-exhibition-florence-italy.jpg"} alt={"2013 “Wind and Sea”, Di Cuore (From the Heart) Exhibition, Palazzo Medici Riccardi, Florence"} />
<figcaption>
<b>{"2013"}</b>{" “Wind and Sea” (XL), Di Cuore (From the Heart) Exhibition,"}<br />{"Palazzo Medici Riccardi, Florence\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/wind-and-water-monument-dublin.jpg"} alt={"2013 “Wind and Sea (XL) ”monument,acquired by University College, Dublin for campus at Belfield"} />
<figcaption>
<b>{"2013"}</b>{" “Wind and Sea” (XL) monument,"}<br />{"acquired by University College,"}<br />{"Dublin for campus at Belfield\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/the-day-that-changed-ireland-sculpture-ireland.jpg"} alt={"2015 “The Day That Changed Ireland”,Rugby sculpture at Shannon Airport, Ireland"} />
<figcaption>
<b>{"2015"}</b>{" “The Day That Changed Ireland”,"}<br />{"Rugby sculpture at Shannon Airport, Ireland\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/il-dolce-rumore-della-vita-pietrasanta-italy.jpg"} alt={"2018 Il Dolce Rumore Della Vita (The Sweet Noise of Life) Exhibition,  Pietrasanta, Italy"} />
<figcaption>
<b>{"2018"}</b>{" Il Dolce Rumore Della Vita (The Sweet Noise of Life) Exhibition,"}<br />{"Pietrasanta, Italy\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/life-and-death-memorial-vicchio-italy.jpg"} alt={"2019 “Life and Death”Memorial to victims of warand terrorism, Vicchio, Tuscany"} />
<figcaption>
<b>{"2019"}</b>{" “Life and Death”Memorial to victims of warand terrorism,"}<br />{"Vicchio, Tuscany\n            "}</figcaption>
</figure>
</li>
<li>
<figure>
<img src={"/assets/images/milestones/Fionnghuala-Daughter-of-Lir-dublin.jpg"} alt={"2021 “Fionnghuala, Daughter of Lir”,Royal Hibernian Academy, Dublin (invited Artist)"} />
<figcaption>
<b>{"2021"}</b>{" “Fionnghuala, Daughter of Lir”,"}<br />{"Royal Hibernian Academy, Dublin (invited Artist)\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/mother-and-child-carrara-marble-florence.jpg"} alt={"2022 “Mother and Child”,in Cararra marble, at Museo Degli Innocenti, Florence"} />
<figcaption>
<b>{"2022"}</b>{" “Mother and Child”, in Cararra marble,"}<br />{"at Museo Degli Innocenti, Florence\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/seven-veils-sculpture-florence.jpg"} alt={"2022 “Seven Veils”,Galeria Frilli Exhibition,Four Seasons Hotel, Florence"} />
<figcaption>
<b>{"2022"}</b>{" “Seven Veils”,Galeria Frilli Exhibition,"}<br />{"Four Seasons Hotel, Florence\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/exhibitions/gormleys/Wind&Sea_Castlemartyr_Gormleys_Exhibtion_Art.jpg"} alt={"2023 Gormleys Exhibition, Castlemartyr Hotel, Cork, Ireland"} />
<figcaption>
<b>{"2023"}</b>{" Wind & Sea (XL), Gormleys Exhibition"}<br />{"Castlemartyr Hotel, Cork, Ireland\n            "}</figcaption>
</figure>
</li>
<li class={"long"}>
<figure>
<img src={"/assets/images/milestones/seven-veils-culloden-belfast.jpg"} alt={"2023 “Seven Veils”, Gormleys Exhibition, Culloden Hotel, Belfast"} />
<figcaption>
<b>{"2023"}</b>{" Seven Veils (L), Gormleys Exhibition"}<br />{"Culloden Hotel, Belfast\n            "}</figcaption>
</figure>
</li>
</ul>
<div class={"container photoLeft"}>
<figure class={"photo"} style={{"flexBasis":"43.9%"}}>
<img src={"/assets/images/milestones/paddy-in-vicchio-receiving-prize.jpg"} alt={"In 2020 Paddy Campbell became the first non-Italian to win the prestigious “Giotto Fra Angelico Award” for his contribution to art and culture in Tuscany"} />
</figure>
<div class={"photo"} style={{"flexBasis":"60%"}}>
<figure>
<img src={"/assets/images/milestones/vicchio.jpg"} alt={"Vicchio, Tuscany"} />
</figure>
</div>
</div>
<p style={{"textAlign":"center","paddingBottom":"60px"}}>{"\n    In 2020 Paddy Campbell became the first non-Italian to win the prestigious “Giotto Fra Angelico Award” for his contribution to art and culture in Tuscany.\n"}</p>
</>;
}
